var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      staticClass: "reset-pwd-container login-pwd-reset",
      attrs: { id: "reset-pwd-form-" + _vm._uid, method: "post" }
    },
    [
      _c(
        "div",
        {
          ref: "pwdModal",
          staticClass: "modal fade",
          attrs: { id: "resetPwd", tabindex: "-1", role: "dialog" }
        },
        [
          _c("div", { staticClass: "modal-dialog" }, [
            _c("div", { staticClass: "modal-content" }, [
              _c("div", { staticClass: "modal-header" }, [
                _c("div", { staticClass: "modal-title h3" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$translate("Ceres::Template.loginForgotPassword")
                    )
                  )
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "close",
                    attrs: {
                      type: "button",
                      "data-dismiss": "modal",
                      "aria-hidden": "true",
                      "aria-label": _vm.$translate("Ceres::Template.closeIcon")
                    }
                  },
                  [_vm._v("×")]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "modal-body" }, [
                _c(
                  "div",
                  { staticClass: "alert alert-info w-100 pwd-forgot-info" },
                  [
                    _c("span", { staticClass: "info-badge" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$translate(
                            "Ceres::Template.loginForgotPasswordInfo"
                          )
                        )
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-12" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.honeypot,
                          expression: "honeypot"
                        }
                      ],
                      staticClass: "honey",
                      attrs: {
                        type: "text",
                        name: "username",
                        autocomplete: "new-password",
                        tabindex: "-1",
                        "aria-hidden": "true",
                        "aria-label": _vm.$translate(
                          "Ceres::Template.loginForgotPassword"
                        )
                      },
                      domProps: { value: _vm.honeypot },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.honeypot = $event.target.value
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "input-unit no-bottom",
                        attrs: { "data-validate": "mail" }
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.username,
                              expression: "username"
                            }
                          ],
                          attrs: {
                            type: "email",
                            name: "email",
                            autocomplete: "email",
                            id: "mail" + _vm._uid,
                            "data-autofocus": ""
                          },
                          domProps: { value: _vm.username },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.username = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("label", { attrs: { for: "mail" + _vm._uid } }, [
                          _vm._v(
                            _vm._s(
                              _vm.$translate("Ceres::Template.loginEmail")
                            ) + "*"
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "error-msg" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$translate(
                            "Ceres::Template.loginEnterConfirmEmail"
                          )
                        )
                      )
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "modal-footer" }, [
                _c(
                  "div",
                  [
                    _vm._t("extend-overlay-buttons"),
                    _vm._v(" "),
                    !!_vm.currentTemplate && _vm.currentTemplate != "tpl.login"
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-danger btn-medium mr-2",
                            attrs: { type: "button" },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.cancelResetPwd($event)
                              }
                            }
                          },
                          [
                            _c("i", {
                              staticClass: "fa fa-arrow-left",
                              attrs: { "aria-hidden": "true" }
                            }),
                            _vm._v(
                              "\n                                " +
                                _vm._s(
                                  _vm.$translate(
                                    "Ceres::Template.loginBackToLogin"
                                  )
                                ) +
                                "\n                            "
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary btn-medium",
                        attrs: { disabled: _vm.isDisabled },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.validateResetPwd($event)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t\t\t\t" +
                            _vm._s(
                              _vm.$translate("Ceres::Template.loginSend")
                            ) +
                            "\n\t\t\t\t\t\t\t\t"
                        ),
                        _c("icon", {
                          attrs: {
                            icon: "paper-plane-o",
                            loading: _vm.isDisabled
                          }
                        })
                      ],
                      1
                    )
                  ],
                  2
                )
              ])
            ])
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }